import { Injectable } from '@angular/core';

import { io, ManagerOptions, SocketOptions } from 'socket.io-client';

import { DomainQuery } from '@common/store/domain.store';
import { SocketImpl } from '@common/types/socket-impl';

import { GlobalNotificationService } from './global-notification.service';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  constructor(
    private domainQuery: DomainQuery,
    private globalNotificationService: GlobalNotificationService,
  ) {}

  init(path: string, options?: Partial<SocketOptions & ManagerOptions>) {
    const apiEndpoint = this.domainQuery.getValue().api?.socket;
    const socket = io(apiEndpoint, { path, ...options });

    return new SocketImpl(socket);
  }
}
